import { render, staticRenderFns } from "./StorageLocations.vue?vue&type=template&id=cdad5ac6&scoped=true&"
import script from "./StorageLocations.vue?vue&type=script&lang=js&"
export * from "./StorageLocations.vue?vue&type=script&lang=js&"
import style0 from "./StorageLocations.vue?vue&type=style&index=0&id=cdad5ac6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdad5ac6",
  null
  
)

export default component.exports